var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHigherEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Higher_Education",
    "data-name": "Higher Education",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9865",
    "data-name": "Path 9865",
    d: "M10,0H83A10,10,0,0,1,93,10V83A10,10,0,0,1,83,93H10A10,10,0,0,1,0,83V10A10,10,0,0,1,10,0Z",
    transform: "translate(455 169)",
    fill: "#fff9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal",
    d: "M4.312,1.058a.869.869,0,0,0-.756,1.3l9.434,16.3V24.5q0,.034,0,.068A13.552,13.552,0,1,0,33.6,36.161a13.5,13.5,0,0,0-6.718-11.639c0-.007,0-.015,0-.022V18.693L36.323,2.359a.869.869,0,0,0-.756-1.3H25.15a.868.868,0,0,0-.743.422L19.94,8.923,15.472,1.481a.868.868,0,0,0-.745-.422ZM5.818,2.8h8.415l4.694,7.816-4.37,7.281Zm19.819,0h8.429L25.008,18.484l-8.754-.049q4.7-7.827,9.384-15.64ZM14.727,20.167l10.423.053v3.435a13.654,13.654,0,0,0-10.423.029Zm5.251,4.206A11.789,11.789,0,1,1,8.087,36.161a11.826,11.826,0,0,1,11.89-11.788Zm-.042,2.755a.87.87,0,0,0-.78.534l-2.089,5-5.422.446a.866.866,0,0,0-.5,1.518l4.128,3.53-1.252,5.266a.869.869,0,0,0,1.3.943l4.64-2.822,4.65,2.817a.869.869,0,0,0,1.3-.943l-1.262-5.266,4.128-3.53a.866.866,0,0,0-.5-1.523l-5.42-.436-2.094-5A.87.87,0,0,0,19.935,27.128Zm.024,3.121,1.5,3.562a.87.87,0,0,0,.734.529l3.868.314-2.942,2.522a.864.864,0,0,0-.282.858l.9,3.762-3.319-2.01a.873.873,0,0,0-.9,0L16.2,41.8l.894-3.762a.864.864,0,0,0-.282-.858l-2.946-2.517,3.868-.314a.87.87,0,0,0,.734-.529Z",
    transform: "translate(481.561 194.812)",
    fill: "#b28400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigherEducation);
export default __webpack_public_path__ + "static/media/Higher-Education.569a323c3fa716c7f886f24057a3923a.svg";
export { ForwardRef as ReactComponent };